import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import portalApi, { getPortalToken, setPortalToken } from "../../lib/portalApi";
import { Lock, Mail, Loader2, LayoutGrid } from "lucide-react";

export default function PortalLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { if (getPortalToken()) navigate("/portail/projets", { replace: true }); }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await portalApi.post("/portal/login", { email, password });
      setPortalToken(data.token);
      navigate("/portail/projets", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Connexion impossible");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#131b33] to-[#0b1224] px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 text-white">
            <LayoutGrid className="w-8 h-8 text-cognac-400" strokeWidth={2.4} />
            <span className="font-display font-bold text-2xl">FABRIKO</span>
          </div>
          <p className="text-slate-400 text-sm mt-2">Espace de suivi client</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-2xl p-6 space-y-4" data-testid="portal-login-form">
          <h1 className="font-display font-bold text-navy text-xl">Suivi de mes projets</h1>
          <p className="text-sm text-slate-500 -mt-2">Connectez-vous avec les identifiants transmis par votre artisan.</p>
          {error && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-xl px-3 py-2" data-testid="portal-login-error">{error}</div>}
          <div>
            <label className="text-xs font-medium text-slate-500">Email</label>
            <div className="mt-1 flex items-center gap-2 px-3 py-2.5 rounded-xl border border-slate-200 focus-within:ring-2 focus-within:ring-cognac-400">
              <Mail className="w-4 h-4 text-slate-400" />
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="portal-email" className="flex-1 text-sm focus:outline-none" placeholder="vous@exemple.fr" />
            </div>
          </div>
          <div>
            <label className="text-xs font-medium text-slate-500">Mot de passe</label>
            <div className="mt-1 flex items-center gap-2 px-3 py-2.5 rounded-xl border border-slate-200 focus-within:ring-2 focus-within:ring-cognac-400">
              <Lock className="w-4 h-4 text-slate-400" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="portal-password" className="flex-1 text-sm focus:outline-none" placeholder="••••••••" />
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="portal-login-submit" className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-cognac-500 text-white font-semibold hover:bg-cognac-600 disabled:opacity-60">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />} Me connecter
          </button>
        </form>
        <p className="text-center text-slate-500 text-xs mt-4">Un souci de connexion ? Contactez votre atelier.</p>
      </div>
    </div>
  );
}
